import dayjs from '@didaskill/services/dayjs';

/**
 * @description This method verifies that the date in parameter is later than the present time.
 * @param time
 * @returns boolean
 */
export const isDateInFuture = (time: Date) => {
  const currentDate = new Date();
  const selectedDate = new Date(time);

  return currentDate.getTime() < selectedDate.getTime();
};

/**
 * @description This method converts a string date to a cron format (ex: "30 5 9 5 2").
 *
 * @param date - Date
 * @returns string
 * ! This function does not handle frequency.
 */
export const convertDateToCronFormat = (date: Date) => {
  const minutes = date.getMinutes();
  const hours = date.getHours();
  const days = date.getDate();
  const months = date.getMonth() + 1;

  return `${minutes} ${hours} ${days} ${months} *`;
};

/**
 * Calculates the number of days remaining until a content or feature becomes accessible,
 * based on a start date and a delay in days.
 *
 * @param startDate - Date when the user has been registered to a course.
 * @param availableAfterDays - Number of days after the access start date
 * before a content is available to the user
 * @returns Days remaining.
 */
export const getRemainingDaysUntilAccess = (
  startDate: string,
  availableAfterDays: number,
): number | null => {
  if (!dayjs(startDate).isValid() || availableAfterDays < 0) {
    return null;
  }

  return dayjs(startDate)
    .startOf('day')
    .add(availableAfterDays, 'day')
    .diff(dayjs().startOf('day'), 'day');
};
